import React, { useState, useEffect, useRef } from "react";
import "./styles/styles.css";
import CircularProgress from '@material-ui/core/CircularProgress';

let autoComplete;
let geocoder;
let center = {};

//Static URL pieces
let zoom = '19'
let urlBase = 'https://maps.googleapis.com/maps/api/staticmap?';
let urlEnd = '&zoom='+zoom+'&size=640x640&maptype=satellite&key=AIzaSyBmYCQTzZ1KbSpYrVnyW6M148qp7d-VimA'

function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

// extract country short name (e.g. GB for Great Britain) from google geocode API result
function getCountry(addrComponents) {
    for (var i = 0; i < addrComponents.length; i++) {
        if (addrComponents[i].types[0] == "country") {
            return addrComponents[i].short_name;
        }
        if (addrComponents[i].types.length == 2) {
            if (addrComponents[i].types[0] == "political") {
                return addrComponents[i].short_name;
            }
        }
    }
    return false;
}

let userId = makeid(12);

function SearchLocationInput() {
    const [query, setQuery] = useState("");
    const [querying, setQuerying] = useState(false)
    const [geocoded, setGeocoded] = useState(false)
    const autoCompleteRef = useRef(null);

    const geocodeAddress = (callback) => {
        //Get lat lon of address
        geocoder.geocode({
            'address': query
        }, (results, status) => {
            if(status == google.maps.GeocoderStatus.OK) {
                center.lat = results[0].geometry.location.lat();
                center.lng = results[0].geometry.location.lng();
                let country = getCountry(results[0].address_components)

                sessionStorage.setItem('OtOCenter', JSON.stringify(center))
                sessionStorage.setItem('OtOStaticUrl', urlBase + 'center='+center.lat+','+center.lng+urlEnd);
                sessionStorage.setItem('userId', userId)
                sessionStorage.setItem('country', country)
                callback()
            }
        })
    }

    async function handlePlaceSelect(updateQuery) {
        const addressObject = autoComplete.getPlace();
        const query = addressObject.formatted_address;

        //Get lat lon of address
        geocodeAddress(() => {
            setGeocoded(true)
        })
        if(query)
            updateQuery(query);
    }

    function handleScriptLoad(updateQuery, autoCompleteRef) {

        //Clear localStorage on first load
        sessionStorage.setItem('OtOCenter', '')
        sessionStorage.setItem('OtOStaticUrl', '');
        sessionStorage.setItem('userId', '')
        sessionStorage.setItem('country', '')
        sessionStorage.setItem('report', 'false')

        autoComplete = new window.google.maps.places.Autocomplete(
            autoCompleteRef.current,
            { types: ["address"], componentRestrictions: { country: ["us", "ca"] } }
        );
        geocoder = new google.maps.Geocoder();
        autoComplete.setFields(["address_components", "formatted_address"]);
        autoComplete.addListener("place_changed", () =>
            handlePlaceSelect(updateQuery)
        );
    }

    const startJourney = () => {
        if(query.length > 0 && !querying){
            sessionStorage.setItem('address', query)

            setQuerying(true)
            if(geocoded){
                window.location.assign('https://otolawn.com/pages/user-journey')
            } else {
                //Get lat lon of address
                geocodeAddress(() => {
                    window.location.assign('https://otolawn.com/pages/user-journey')
                })
            }
        }
    }

    useEffect(() => {
        handleScriptLoad(setQuery, autoCompleteRef)
    }, []);

    const handleChange = (value) => {
        setQuery(value)
    }

    return (
        <>
            <form className="search-location-input" style={styles.searchInputWrapper} onSubmit={e => e.preventDefault()}>
                <input
                    style={{width: '30%', minWidth: 280, height: 60, fontSize: 18}}
                    ref={autoCompleteRef}
                    onChange={event => {handleChange(event.target.value)}}
                    placeholder="start typing to find your address…"
                    value={query}
                />
                <div className={`user-journey-btn btn ${(query ? query.length === 0 : !query) || querying ? "disabled" : ""}`} style={{position: 'relative', height: 60, display: 'flex', alignItems: 'center', marginTop: 12, paddingLeft: 40, paddingRight: 40}} onClick={startJourney}>
                    get started
                    {querying &&
                        <div style={styles.querying}>
                            <CircularProgress color="primary" />
                        </div>
                    }
                </div>
            </form>
        </>
);
}


const styles = {
    searchInputWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    querying: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.6)',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0
    }
}

export default SearchLocationInput;